<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
	created() {
		//console.log('App created');
	},
	mounted(){
		//console.log('App mounted');
	},
	methods: {
		
	},
}
</script>
<style lang="scss">
*{
  margin:0;
  padding: 0;
}
#app{
 width: 100%;
 height: 100%;
}
</style>